import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { GlobalService } from './global.service';
import { PersonSearchService } from './person-search.service';
import * as _ from 'underscore';

const devUrl = environment.backendurl;

export type COMPANY_INSIGHTS_TAB_NAMES = 'overview' | 'location' | 'attritionandhiring' | 'education' | 'skills' | 'titles' | 'talentmovement' | 'profile' | 'diversity';

/**
 * Data structure of each request object for talent insights export
 */
export interface ExportRequest {
  type: string
  action?: string
  data: {
    currentTab: COMPANY_INSIGHTS_TAB_NAMES
  }
}

/**
 * Data structure of each service payload object for talent insights export
 */
export interface ExportPayload {
  type?: string
  tab: COMPANY_INSIGHTS_TAB_NAMES
  totalresultcount?: number
  data?: any
  aiData?: string
  aiRequestFilters?: any
  aiRequestPayload?: any[]
  [key: string]: any
}

export interface companyComparePayload {
  companyone: {
    id?: string;
    name?: string;
  }[],
  companytwo: {
    id?: string;
    name?: string;
  }[]

}

export interface companyFilter{
  industry: string[];
  companysize: string[];
  locations: string[],
  fortune?: Boolean
  unicorn?: Boolean,
  search?: string
}

export interface companyCompareAI {
  company_one?: Object,
  company_two?: Object,
  companyname: string[],
  paramcompany_one?: {
    "funding"?: string,
    "revenue"?: string
  },
  paramcompany_two?: {
    "funding"?: string,
    "revenue"?: string
  }
}



@Injectable({
  providedIn: 'root'
})

export class CompanyInsightsService {
  public companyListData: any = null;
  private companyData : any = null;
  public companycompareone: Array<{ id: string, name: string, companylogo?: string }> = [];
  public companycomparetwo: Array<{ id: string, name: string, companylogo?: string }> = [];
  public companySearch: string = null;

  /**
   * Observable for handling insights-export request signal
   */
  private insightsExportRequestObservable: Subject<any> = new Subject();
  /**
   * Observable for handling insights-export data sharing
   */
  private insightsExportDataObservable: Subject<any> = new Subject();
  /**
   * Observable for storing data of company which is to be compared
   */
  private companyCompareObservable: Subject<any> = new Subject();
  /**
   * Observable for storing compaany filter data
   */
  private companyFilterDataObservable: Subject<any> = new Subject();
  private compnyCompareforAIObservable: Subject<any> = new Subject();
  private companyExportObservable: Subject<any> = new Subject();
  private companySearchOnservable: Subject<any> = new Subject();
  private companyCompareExportObservable: Subject<any> = new Subject();

  constructor(private http: HttpClient, private personSearchService: PersonSearchService) { }

  /**
   * Getter for insights-export request observable
   */
  get insightsExportRequestEvent(): Observable<any> {
    return this.insightsExportRequestObservable.asObservable();
  }

  /**
   * Getter for insights-export request observable
   */
  get insightsExportDataEvent(): Observable<any> {
    return this.insightsExportDataObservable.asObservable();
  }

  /**
   * Send request for insights export
   * @param requestData
   */
  sendInsightsExportRequest(requestData: ExportRequest) {
    this.insightsExportRequestObservable.next(requestData);
  }

  /**
   * Emit data for insights export
   * @param exportData
   */
  sendInsightsExportData(exportData: ExportPayload) {
    this.insightsExportDataObservable.next(exportData);
  }


    /**
   * Getter for CompanyCompareData
   */
  get companyCompareDetails(): Observable<any> {
    return this.companyCompareObservable.asObservable();
  }
  /**
   * Store data of companycompare
   */
   sendCompanyCompareDetails(requestData: companyComparePayload) {
    this.companyCompareObservable.next(requestData);
  }
/**
 * fetch company filter Data
 */

  get fetchCompanyFilterData() :  Observable<any> {
    return this.companyFilterDataObservable.asObservable();
  }
/**
 * Store company filter data
 */
  setCompanyFilterData(filterData: companyFilter) {
    this.companyFilterDataObservable.next(filterData);
  }

  /**
 * fetch company filter Data
 */

   get fetchCompanyComparisonForAI() :  Observable<any> {
    return this.compnyCompareforAIObservable.asObservable();
  }
/**
 * Store company filter data
 */
  setCompanyComparisonforAI(filterData: companyCompareAI) {
    this.compnyCompareforAIObservable.next(filterData);
  }


  /**
 * fetch company export Data
 */

   get fetchCompanyExportData() :  Observable<any> {
    return this.companyExportObservable.asObservable();
  }
/**
 * Store company filter data
 */
  setCompanyExportData(filterData: any) {
    this.companyExportObservable.next(filterData);
  }

    /**
 * fetch company export Data
 */

     get fetchCompanySearchData() :  Observable<any> {
      return this.companySearchOnservable.asObservable();
    }
  /**
   * Store company filter data
   */
    setCompanySearschData(search: string) {
      this.companySearchOnservable.next(search);
    }

      /**
 * fetch company export Data
 */

   get fetchCompanyCompareExportData() :  Observable<any> {
    return this.companyCompareExportObservable.asObservable();
  }
/**
 * Store company filter data
 */
  setCompanyCompareExportData(filterData: any) {
    this.companyCompareExportObservable.next(filterData);
  }
  getRecommendedcompanies(payload: any){
    var url = devUrl + `/company/recommendcompanies`;
    return this.http.post(url, payload).pipe(
      map((response) => {
        return response;
      }),
      catchError(GlobalService.handleError("get recommended companies", url))
    );
  }

  getIndustryAggregates(payload:any) {
    var url = devUrl + `/company/aggregates`;
    return this.http.post(url, payload).pipe(
      map((response) => {
        return response;
      }),
      catchError(GlobalService.handleError("get aggregates", url))
    );
  }

  getCompanyTypeaheads(keyword: string) {
    const encodedValue = encodeURIComponent(keyword);
    var url = devUrl + `/company/typeaheads?keyword=${encodedValue}`;
    return this.http.get(url).pipe(
      map((response) => {
        return response;
      }),
      catchError(GlobalService.handleError("get aggregates", url))
    );
  }

  setCompanyListData(data: any): void {
    this.companyListData = data;
    setTimeout(() => this.companyListData = [], 2000);
  }
  getCompanyListData(): any {
    return this.companyListData;
  }

  setCompanyData(data: any) {
    this.companyData = Object.assign({}, data);
  }
  get fetchCompanyData() {
    return this.companyData;
  }




  getCompanyDetailsById(companyId: any) {
    const queryParams = { id: companyId };
    const url = devUrl + `/company/detailsbyid`;
    return this.http.get(url, { params: queryParams }).pipe(
      map((response) => {
        return response;
      }),
      catchError(GlobalService.handleError("get company details", url))
    );
  }

  getTotalCompanyaggs(requestobject):  Observable<any> {
    requestobject['calledvia'] = "companypages";
    requestobject['companytype'] = "Current";
    requestobject['jobtitletype'] = "Current";
    requestobject['industrytype'] = "Current";
    requestobject['functiontype'] = "Current";

    const url = devUrl + '/personsearch/aggregates';
    return this.http.post<any>(url, requestobject).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  getchangedjobscount(requestObject): Observable<any> {
    const url = devUrl + '/personsearch/changedjobscount';
    return this.http.post(url, requestObject).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  getcompanywinningTalentFrom(requestObject): Observable<any> {
    const url = devUrl + '/personsearch/companywinningtalentfrom';
    return this.http.post(url, requestObject).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  getcompanylosingtalentto(requestObject): Observable<any> {
    const url = devUrl + '/personsearch/companylosingtalentto';
    return this.http.post(url, requestObject).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  getcompanyinsightssummary(requestObject): Observable<any> {
    const url = devUrl + '/openai/companyinsightssummary';
    return this.http.post(url, requestObject).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  /**
   * Export insights report to PDF
   * @param companyId
   * @param payload
   */
  exportInsightsToPDFReport(companyId: string, payload: any): Observable<any> {
    const url = devUrl + `/personsearch/company/${companyId}/insights/export`;
    return this.http.post(url, payload).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Company Insights Export to PDF', url)));
  }

  /**
   * Export insights report to Excel
   * @param payload
   */
  exportInsightsToExcelReport(payload: any): Observable<any> {
    const url = devUrl + `/personsearch/company/insights/export-excel`;
    return this.http.post(url, payload).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Company Insights Export to PDF', url)));
  }

  /**
   * Used to get recent search and complete histroy with pagination of company insights
   * @param page page for pagination
   */
  async getCompanyInsightsRecentSearchAndHistory(page = 0) {

    /**List of all search */
    const historyData: {
      type: string,
      name: string,
      companylogo: string | null,
      companyid: string | null,
      updatedon: string | null
    }[] = [];


    /**List of all search */
    let recentSearchData: {
      type: string,
      name: string,
      companylogo: string | null,
      companyid: string | null,
      updatedon: string | null
    }[] = [];

    try {
      const resp1 = await this.personSearchService.getSearchHistory(page, GlobalService.HISTORY_MODULE.COMPANY_COMPARISON).toPromise();
      if (!(resp1.status == 'success' && Array.isArray(resp1.message) && resp1?.message?.length)) {
        return { historyData, recentSearchData };
      }
      resp1.message.map(data => {
        const queryObj = JSON.parse(data.query);
        if(queryObj.companies.includes(';')) {
          queryObj.company = queryObj.companies.split(';');
          queryObj.id = queryObj.companyids.split(';');
          const parts = queryObj.companies.split(';').map(name => this.capitalizeFirstLetter(name.trim()));
          const company = parts.join(' vs ');
          const obj = {
            type: 'company comparison',
            name: company,
            companylogo: null,
            companyid: queryObj.companyids,
            updatedon: data.updatedon,
            id: queryObj.id
          }
          if (obj.name) historyData.push(obj);

        } else {
        const obj = {
          type: 'company',
          name: queryObj.companies,
          companylogo: null,
          companyid: queryObj.companyids,
          updatedon: data.updatedon,
        }
        if (obj.name) historyData.push(obj);

      }
      })

      const companyLogoPayload = historyData.map(item => {
        if (item?.type === 'company' && (item.companyid || item.name)) {
          return {
            ...(item.companyid && { id: item.companyid }),
            ...(item.name && { name: item.name })
          }
        }
      }).filter(Boolean);

      const logoMapping = new Map();
      const resp2 = companyLogoPayload.length && await this.personSearchService.getCompanyLogoV2(companyLogoPayload).toPromise();

      resp2?.data?.map((item: any) => {
        logoMapping.set(item.key, { logo: item.companylogo, companyid: item.id });
      })
      historyData.forEach(item => {
        if (item?.type == 'company' && logoMapping.has(item.companyid)) {
          if (item?.companyid) {
            item['companylogo'] = logoMapping.get(item.companyid)['logo'];
          } else if (item?.name) {
            item['companylogo'] = logoMapping.get(item.name)['logo'];
          }
        }
      })

      recentSearchData = _.uniq(historyData, 'name').slice(0, 5);
      return { historyData, recentSearchData };
    } catch (err) {
      return { historyData, recentSearchData };
    }
  }

  capitalizeFirstLetter(str: string): string {
     return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
  }

  /**
   * Used to set history on search in company insights
   * @param data
   * @param selectionType e.g. company or industry
   */
  setCompanyInsightsHistory(data: { companies: string[], id?: string[] }, selectionType: string) {
    const payload = {
      ...((selectionType === 'company') && {
        companies: data.companies,
        companyids:
          data.id
      }),
      ...((selectionType === 'company comparison') && {
        companies: data.companies,
        companyids:
          data.id
      }),
      module: GlobalService.HISTORY_MODULE.COMPANY_COMPARISON

    }
    this.personSearchService.setInsightsHistory(payload).subscribe();
  }


  // /personsearch/similarcompanies


  getSimilarCompanies(requestObject): Observable<any> {
    const url = devUrl + '/personsearch/similarcompanies';
    return this.http.post(url, requestObject).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Get Person Search Listing', url)));
  }

  exportInsights(requestObject): Observable<any> {
    const url = devUrl + '/personsearch/company-comparison/insights/export';
    return this.http.post(url, requestObject).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Export insights', url)));
  }

    suggestedCompanyCompare(): Observable<any> {
    const url = devUrl + '/personsearch/suggested-companies-compare ';
    return this.http.get(url).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Suggested CompanyCompare', url)));
  }


  // openai/companyinsightssummary
}

